import React from "react";
import { InputField } from "components/fields";

/**
 * Hex color input with a native color picker beside it. Both edit the same value.
 */
const ColorField = ({ label, value, onChange, placeholder, className = "" }) => (
  <div className={`flex items-end gap-2 ${className}`}>
    <input
      type="color"
      aria-label={`${label} picker`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="focus-ring h-10 w-12 shrink-0 cursor-pointer rounded-control border border-line bg-surface p-1"
    />
    <InputField
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      spellCheck={false}
      autoComplete="off"
      className="min-w-0 flex-1"
    />
  </div>
);

export default ColorField;
